import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import HeaderZaptrance from './HeaderZaptrance';
import ZaptranceSideNav from './ZaptranceSideNav';
import axios from 'axios';

import AddUserModal from './modals/AddUserModal';
import PeopleIcon from '@mui/icons-material/People';

const ZaptranceLogout = ({ onLogout }) => {
  const navigate = useNavigate();
    

  useEffect(() => {
    // Get user type from localStorage
    const userType = localStorage.getItem('user_type');

    // Clear the entire localStorage
    //localStorage.clear();
    //

    console.log("1." + userType);
    if (userType === 'zaptrance' || userType === 'admin' || userType === 'rector' || userType === 'registrar') {
      navigate('/secure-nbte-login');
    } else {
      navigate('/login');
    }


    //localStorage.clear();
    onLogout();
  }, [onLogout, navigate]);
  

  return (
    <div></div>
  );
};

export default ZaptranceLogout;
